import type { GooglePlacesPriceLevel } from 'tripPlanner/types/common'

export type GooglePlacesDollarPriceLevel = Extract<
  GooglePlacesPriceLevel,
  | 'PRICE_LEVEL_INEXPENSIVE'
  | 'PRICE_LEVEL_MODERATE'
  | 'PRICE_LEVEL_EXPENSIVE'
  | 'PRICE_LEVEL_VERY_EXPENSIVE'
>

const GOOGLE_PLACES_DOLLAR_PRICE_LEVELS: ReadonlySet<string> = new Set<GooglePlacesDollarPriceLevel>([
  'PRICE_LEVEL_INEXPENSIVE',
  'PRICE_LEVEL_MODERATE',
  'PRICE_LEVEL_EXPENSIVE',
  'PRICE_LEVEL_VERY_EXPENSIVE',
])

export function getGooglePlacesDollarPriceLevel(value: unknown): GooglePlacesDollarPriceLevel | undefined {
  return typeof value === 'string' && GOOGLE_PLACES_DOLLAR_PRICE_LEVELS.has(value) ? value as GooglePlacesDollarPriceLevel : undefined
}
